import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useRestrictToLoggedInAndVerified } from '@wix/da-shared-react/pkg/utils/hooks/useRestrictToLoggedInAndVerified';
import Button, {
  ProfileOwnerWatchButton,
} from '@wix/da-shared-react/pkg/Button';
import SaleBanner from '@wix/da-shared-react/pkg/SaleBanner';
import { useCurrentPromo } from '@wix/da-shared-react/pkg/utils/hooks/useCurrentPromo';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import SubNavBarMobileInner from './SubNavBarMobileInner';
import { SubNavBarProps } from '../SubNavBar';
import WatchButtonConneсtContainer from '../WatchButton.container';

import cssVars from '@wix/da-ds/src/styles/variables.scss';
import s from './SubNavBarMobile.scss';

const WatchButtonMobile = WatchButtonConneсtContainer(ProfileOwnerWatchButton);

const SubNavBarMobile: React.FC<SubNavBarProps> = ({
  isOwner,
  isMobile,
  routes,
  biClickProfileNavBar,
  isViewingAsVisitor,
  profileOwnerUser,
  isProfileOwnerWatchingCurrentUser,
  isLoggedIn,
  restrictLoggedOut,
  onStartChat,
}) => {
  const isProfileWatchBackFlagEnabled = useFlag('profile_watch_back');
  const currentPromo = useCurrentPromo('gift');
  const { t } = useTranslation();

  // T42244: The sticky header gets stuck a pixel too low sometimes
  const stickyHeight = parseInt(cssVars['site-header-height-mobile']) - 1;

  const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();

  const showSaleBanner =
    !isOwner && !!currentPromo && profileOwnerUser.type === 'regular';

  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="SubNavBarMobile">
        {!isOwner && (
          <div className={s['action-buttons']}>
            <Button
              view="b2"
              fullWidth={false}
              className={s['message-btn']}
              onClick={restrictToLoggedInAndVerified(
                ReferralType.CHAT,
                'chat',
                () => onStartChat(profileOwnerUser)
              )}
              height="large"
            >
              {t!(`common.chat`)}
            </Button>
            <WatchButtonMobile
              className={s['watch-btn']}
              disableClickHandler={isViewingAsVisitor}
              useV2Styles={false}
              height="large"
              hidePlusIcon={
                isProfileWatchBackFlagEnabled &&
                !!isProfileOwnerWatchingCurrentUser
              }
              isWatchingBack={
                isProfileWatchBackFlagEnabled &&
                !!isProfileOwnerWatchingCurrentUser
              }
            />
          </div>
        )}

        {showSaleBanner && currentPromo && (
          <div className={s['sale-banner']}>
            <SaleBanner
              isNarrow={isMobile}
              className={s['sale-banner']}
              giftRecipient={profileOwnerUser.username}
              discountValuePercent={currentPromo.discountValuePercent}
              endDate={currentPromo.endDate}
              referralType={ReferralType.PROMOTION_BANNER_PROFILE}
            />
          </div>
        )}

        <div className={s['sticky-placeholder']}>
          <Sticky zIndex={parseInt(s['z-index'])} marginTop={stickyHeight}>
            {isSticky => (
              <SubNavBarMobileInner
                routes={routes}
                isSticky={isSticky}
                biClickProfileNavBar={biClickProfileNavBar}
              />
            )}
          </Sticky>
        </div>
      </ErrorBoundary>
    </div>
  );
};

SubNavBarMobile.displayName = 'SubNavBarMobile';
export default withRouter(SubNavBarMobile);
